import { pureBreedElements } from '@flows/configs/petHealthV2/steps/elements/breeds'
import {
  fetchBreedOptions,
  nextStepAfterBreeds,
  submitBreeds,
} from '@flows/configs/petHealthV2/utils'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const pure_breed_name = (params: StepConfigParams) =>
  ({
    ...fragmentStep(pureBreedElements(params), params, nextStepAfterBreeds('native', params)),
    onPrepare: fetchBreedOptions(params),
    onSubmit: submitBreeds(params, 'pedigree', [
      params.helperFunctions.getParamPath('first_breed_name'),
    ]),
  }) as const satisfies AnyStepConfiguration

export default pure_breed_name
